/* src/app/views/smart-filters/forms/add-edit-smart-filter-form/terpene-add-edit-smart-filter-form/terpene-add-edit-smart-filter-form.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.modal-padding {
  padding: 0 0 1.5rem 0;
}
.terpene-title {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 1rem;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #9fa2ad;
  line-height: 0.1em;
  margin: 0.625rem 0 1.25rem;
}
.terpene-title .text {
  background-color: #ffffff;
  padding: 0 1.5rem 0 0;
}
/*# sourceMappingURL=terpene-add-edit-smart-filter-form.component.css.map */
